import { PacmanLoader } from "react-spinners"

const Spinner = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="h-screen flex justify-center items-center">
            <div role="status text-center">
                <PacmanLoader
                    size={100}
                    className="mx-auto"
                    color={'#22c55e'}
                />
                <p className="text-lg font-medium">{children ? children : null}</p>
            </div>
        </div>
    )
}
export default Spinner
